import $ from 'jquery';
import Globals from '@/helpers/globals';

const { $body } = Globals;

const Feedback = {
    init() {
        $body.on('click', '.js-feedback', () => this.feedbackHide());

        if (!$('.js-message').length) return;

        this.feedbackLoad({
            message: $('.js-message').html(),
            classes: $('.js-message').hasClass('error') ? 'error' : '',
            closable: true,
            time: parseInt($('.js-message').attr('data-time'), 10) || 0,
        });
    },

    feedbackLoad(params) {
        this.params = params;
        this.time = (typeof params.time !== 'undefined') ? params.time : 4500;
        this.classes = (typeof params.classes !== 'undefined') ? params.classes : '';
        this.classes += (params.closable) ? ' closable' : '';
        this.x = (params.x) ? params.x : false;
        this.y = (params.y) ? params.y : false;
        this.coords = {};
        this.feedbackShow();
    },

    feedbackShow() {
        $('.feedback').remove();
        clearTimeout(this.timer);

        $body.addClass('feedback-open');

        const markup =
            `<div class="js-feedback feedback ${this.classes}">
                <div class="feedback-entry">
                    <p class="feedback-message">${this.params.message}</p>
                </div>
                <button class="feedback-close" aria-label="Close">&times;</button>
            </div>`;

        $body.append(markup);

        if (this.time !== 0) {
            this.timer = setTimeout(() => {
                $('.js-feedback').fadeOut(() => {
                    $(this).remove();
                });
            }, this.time);
        }
    },

    feedbackHide() {
        clearTimeout(this.timer);
        $body.removeClass('feedback-open');

        $('.feedback').fadeOut(() => {
            $body.removeClass('feedback-open');
            $(this).remove();
        });
    },
};

export default Feedback;
